import {
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";

import BrandMark from "../BrandMark";

const socials = [
  {
    label: "WhatsApp",
    href: "https://wa.me/message/7PUPDXBNVORFM1",
    icon: FaWhatsapp,
  },
  {
    label: "E-mail",
    href: "mailto:contato@cleisson.adv.br",
    icon: FaEnvelope,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/cleisson-oliveira-4a6578237/",
    icon: FaLinkedinIn,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/cleisson.adv/",
    icon: FaInstagram,
  },
  {
    label: "Telegram",
    href: "https://t.me/cleissonop",
    icon: FaTelegramPlane,
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-amber-950/10 bg-[#f4ede1] text-slate-900">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-center gap-4">
            <BrandMark />
            <div>
              <p
                className="text-[1.06rem] font-bold text-amber-700 sm:text-[1.16rem]"
                style={{
                  fontFamily: '"Cormorant Garamond", Georgia, serif',
                  letterSpacing: "0.1em",
                  wordSpacing: "0.28em",
                }}
              >
                Cleisson Oliveira
              </p>
              <p className="mt-1 text-sm text-slate-500">
                OAB/GO 63.812 • Rio Verde - GO
              </p>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            {socials.map((item) => {
              const Icon = item.icon;

              return (
                <a
                  key={item.label}
                  href={item.href}
                  className="inline-flex items-center gap-2 rounded-full border border-amber-950/10 bg-white px-4 py-2 text-sm text-slate-700 transition hover:border-amber-500/30 hover:bg-amber-50 hover:text-slate-950"
                >
                  <Icon className="text-base text-amber-700" />
                  {item.label}
                </a>
              );
            })}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-amber-950/10 pt-6 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Cleisson Oliveira Advocacia. Todos os direitos reservados.</p>
          <p>Atendimento presencial e online.</p>
        </div>
      </div>
    </footer>
  );
}
